import React from 'react'

const Logo = ({src, alt, logo, style, hidden, hiddenStyle}) => {
    if(hidden) {
        return (<div style={{...hiddenStyle}}></div>)
    }

    if(!logo) {
        return (<React.Fragment></React.Fragment>);
    }
    
    const inlineStyle = { maxHeight: '5rem' }

    return (<img style={{...style, ...inlineStyle}}  src={src} alt={alt}/>)

}

export default Logo